import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";
import { useState } from "react";
import { globalUpdate } from "../../apis/Iot";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
function IotHeader() {
const [restartDevice , setGlobalUpdate] = useState(false)


    const auth = useSelector((state) => state.auth);
console.log(auth)
      const openGlobal = () => setGlobalUpdate((v) => !v)
      const closeGlobal = () => setGlobalUpdate(false)
  
      const handleUpdate = async()=>{
    const response = await globalUpdate(auth?.token)
      toast.success("Request sent successfully")
        console.log('response', response);
  }
  return (
    <nav className="flex items-center justify-between px-6 py-4 ">
      {/* Logo Section */}
      <div className="w-[90px] items-center space-x-2">
        <img
          src={Logo} // Replace with actual path
          alt="Close Carbon Logo"
          className="h-[90px] w-[90px] object-fill ml-[48px]"
        />

      </div>

      {/* Title Section */}
      <h1 className="text-green-700 text-[24px] font-semibold text-center  flex-1">
        IOT DEVICES INTERFACE
      </h1>

      {/* Button Section */}
      <div className="flex-shrink-0 ">
        <button onClick={openGlobal} className="bg-gradient-to-r w-[104px] h-[50px] mr-[30px] text-[16px] from-green-600 to-cyan-500 text-white px-6 py-2 rounded-md text-sm font-medium shadow hover:opacity-90 transition">
          Global Update
        </button>

         {/* overlay for Global update */}
        {
          restartDevice && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 " onClick={closeGlobal}>

              <div children="relative">
                <div className="bg-white p-10 w-[542px] h-[367px] text-center pt-[50px] rounded-xl "> 
                  <div className="float-right"> 
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.75781 17.2438L12.0008 12.0008L17.2438 17.2438M17.2438 6.75781L11.9998 12.0008L6.75781 6.75781" stroke="#D42620" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                    </div>
                  <div className="font-semibold text-[24px] pt-20">
                Global Update

                    </div>
                
                <div className="mt-10 text-gray-500 text-[16px]">
You’re about to update all IoT Device. This action will push the latest configuration or firmware to every device listed.  </div>
                  <div className="flex justify-self-center pt-24 gap-10">
                    <button className="p-5 w-[184.5px] bg-[#E5E5E5] rounded-xl">Cancel</button>
                    <button className="p-5 text-white w-[184.5px] bg-gradient-to-r rounded-xl from-[#038B47] to-[#00AED9] hover:from-green-700  hover:to-green-600 " onClick={handleUpdate}> Continue</button>
                    </div>
</div>
              </div>


              </div>
          )
        }
      </div>
    </nav>
    
    
  )
}

export default IotHeader
